import { useState, forwardRef } from 'react';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

export type SSNInputProps = React.InputHTMLAttributes<HTMLInputElement> &
  FieldWrapperPassThroughProps & {
    className?: string;
    value: string;
    onChange: (value: string) => void;
  };

export function formatSSN(ssn: string, mask: boolean): string {
  const cleaned = ssn.replace(/\D/g, '').slice(0, 9);

  if (cleaned.length <= 3) return cleaned;

  if (cleaned.length <= 5) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;

  if (mask) return 'XXX-XX-' + cleaned.slice(5);
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
}

const SSNInput = forwardRef<HTMLInputElement, SSNInputProps>(
  ({ className, disabled, label, errorMessage, value, onChange, ...props }, ref) => {
    const inputId = label;

    const [inputValue, setInputValue] = useState(disabled ? formatSSN(value, true) : value);

    function parseSSN(str: string): string {
      return str.replace(/\D/g, '').slice(0, 9);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const rawValue = parseSSN(e.target.value);
     
      setInputValue(!disabled ? formatSSN(rawValue, false) : rawValue);

      onChange(!disabled ? formatSSN(rawValue, false) : rawValue);
    };

    const handleBlur = () => {
      setInputValue(!disabled ? formatSSN(value, true) : value);
    };

    return (
      <FieldWrapper
        label={label}
        errorMessage={errorMessage}
        float={true}
        className={className}
        htmlFor={inputId}
      >
        <input
          ref={ref}
          id={inputId}
          type="text"
          aria-required="true"
          placeholder={label}
          aria-invalid={errorMessage ? 'true' : 'false'}
          className={`iLendingCDX-text-field__float ${errorMessage && 'iLendingCDX-text-field__float--error'}`}
          value={inputValue}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
   
          {...props}
        />
      </FieldWrapper>
    );
  }
);

export { SSNInput };
